import posthog from "posthog-js"

export function http(
  url: string | URL | Request,
  init: RequestInit = {},
): Promise<Response> {
  const sessionId = posthog.get_session_id()

  return fetch(url, {
    credentials: "include",
    ...init,
    headers: {
      ...init.headers,
      "X-POSTHOG-SESSION-ID": sessionId,
    },
  })
}
